import { films } from "@/mocks/films";

const featured = films.slice(0, 4);

export default function Hero() {
  return (
    <section id="top" className="relative w-full pt-16 md:pt-20">
      <div className="relative w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=stylized%20vintage%201990s%20cinema%20hall%20with%20warm%20amber%20lighting%2C%20rows%20of%20empty%20red%20velvet%20seats%2C%20a%20beam%20of%20projector%20light%20cutting%20through%20gentle%20dust%2C%20abstract%20nostalgic%20atmosphere%20with%20subtle%20film%20grain%2C%20deep%20warm%20tones%2C%20artistic%20cinematic%20composition%2C%20no%20text&width=1920&height=1080&seq=cinema-hero-hall-v1&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-950/60 to-primary-950/80" />
        <div className="film-grain absolute inset-0 opacity-40" />

        <div className="relative w-full px-4 md:px-8 pt-14 md:pt-24 pb-10 md:pb-14">
          <div className="max-w-4xl mx-auto text-center">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/15 border border-accent-400/40 text-accent-100 text-xs md:text-sm font-label">
              <i className="ri-time-line text-base" />
              怀旧光影 · 老片片库 · 九十年代
            </span>
            <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-6xl font-bold leading-tight text-background-50">
              九七电影院
            </h1>
            <p className="mt-3 font-heading text-lg md:text-2xl text-accent-100">
              老电影、怀旧片与经典港片的整理与导览
            </p>
            <p className="mt-5 text-sm md:text-base leading-relaxed text-background-100 max-w-2xl mx-auto">
              这里面向怀旧老片片库需求，整理了老电影、怀旧片、经典港片与九十年代电影，
              并补充老片在线与怀旧剧场两个方向，帮助你按年代与类型逐步查找到想看的作品。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="#library"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-primary-950 text-sm font-label font-medium whitespace-nowrap hover:bg-accent-400 transition-colors"
              >
                <i className="ri-movie-2-line text-base" />
                浏览影片库
              </a>
              <a
                href="#theater"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-100/50 text-background-50 text-sm font-label whitespace-nowrap hover:bg-background-50/10 transition-colors"
              >
                <i className="ri-calendar-schedule-line text-base" />
                查看怀旧剧场排片
              </a>
            </div>
          </div>

          <div className="mt-12 md:mt-16 max-w-6xl mx-auto">
            <div className="flex items-center justify-between gap-4 mb-4">
              <div className="flex items-center gap-3">
                <span className="h-px w-8 bg-accent-400" />
                <span className="font-label text-xs tracking-[0.3em] text-accent-200 uppercase">
                  Featured Picks
                </span>
              </div>
              <a
                href="#library"
                className="hidden sm:inline-flex items-center gap-1 text-xs md:text-sm font-label text-background-100 hover:text-accent-100 whitespace-nowrap"
              >
                查看全部 12 部
                <i className="ri-arrow-right-line" />
              </a>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
              {featured.map((film) => (
                <a
                  key={film.id}
                  href="#library"
                  className="group block rounded-lg overflow-hidden border border-background-100/20 bg-primary-950/40 backdrop-blur-sm"
                >
                  <div className="relative w-full aspect-[3/4] overflow-hidden">
                    <img
                      src={film.poster}
                      alt={`${film.title} 影片封面`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-primary-950/70 text-accent-100 text-[11px] font-label">
                      {film.year}
                    </span>
                  </div>
                  <div className="px-3 py-3">
                    <h3 className="font-heading text-sm md:text-base font-semibold text-background-50 truncate">
                      {film.title}
                    </h3>
                    <p className="mt-1 text-[11px] md:text-xs text-background-200 truncate">
                      {film.en}
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}